import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import styled from "styled-components";
import logo from "../../assets/img/svg/listino-logo-horizontal-primary.svg";
import { landingPage } from "../../constants/descriptions";

const FooterContainer = styled.footer`
  background: var(--brand-bg-soft);
  border-top: 1px solid var(--brand-border);
  padding: 60px 0 40px;
`;

const FooterTop = styled.div`
  margin-bottom: 40px;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;

  img {
    width: 120px;
    height: auto;
  }
`;

const FooterTitle = styled.h3`
  font-size: 28px;
  font-weight: 700;
  color: var(--brand-ink);
  margin-bottom: 20px;
`;

const FooterDescription = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: var(--brand-ink-3);
  margin-bottom: 24px;
  max-width: 800px;
`;

const ContactInfo = styled.div`
  margin-bottom: 32px;
`;

const ContactLabel = styled.p`
  font-size: 16px;
  color: var(--brand-ink-3);
  margin-bottom: 8px;
`;

const ContactEmail = styled.a`
  font-size: 16px;
  color: var(--brand-ink);
  font-weight: 600;
  text-decoration: none;

  &:hover {
    color: #4b5563;
    text-decoration: underline;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid var(--brand-border);
  padding-top: 32px;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const FooterLink = styled(Link)`
  font-size: 16px;
  color: var(--brand-ink-3);
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: var(--brand-ink);
    text-decoration: none;
  }
`;

const FooterEmailLink = styled.a`
  font-size: 16px;
  color: var(--brand-ink-3);
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: var(--brand-ink);
    text-decoration: none;
  }
`;

const NewFooter = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterTop>
          <Row>
            <Col lg="8">
              <LogoSection>
                <img src={logo} alt="Listino logo" />
              </LogoSection>
              <FooterTitle>{landingPage.footer.title}</FooterTitle>
              <FooterDescription>{landingPage.footer.description}</FooterDescription>
              <ContactInfo>
                <ContactLabel>Email us at</ContactLabel>
                <ContactEmail href={`mailto:${landingPage.footer.email}`}>
                  {landingPage.footer.email}
                </ContactEmail>
              </ContactInfo>
            </Col>
          </Row>
        </FooterTop>

        <FooterBottom>
          <FooterLinks>
            <FooterLink to="/pricing">Pricing</FooterLink>
            <FooterLink to="/listing-photos-and-video">Photos &amp; Video</FooterLink>
            <FooterLink to="/about">About Us</FooterLink>
            <FooterLink to="/resources">Resources</FooterLink>
            <FooterLink to="/faq">FAQ</FooterLink>
            <FooterEmailLink href="mailto:contact@listino.ai">Contact Us</FooterEmailLink>
            <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
            <FooterLink to="/terms-and-conditions">Terms & Conditions</FooterLink>
          </FooterLinks>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

export default NewFooter;
